import { centerOfMass } from '@turf/turf'
import { useGetGeographicPinInteractionHandler } from 'pages/siteView/mapInteraction/UseGetGeographicPinInteractionHandler'
import { FC, HTMLAttributes, MouseEvent, ReactNode, useState } from 'react'
import { Marker } from 'react-map-gl'
import styled from 'styled-components'
import { GeckoGeographicPin } from 'types'

import { LabelDisplay } from './baseComponents/MarkerLabelDisplay'

interface MapboxGeographicPinFeatureProps {
  name: string
  color: string
  onClick: (e: MouseEvent) => void
  hoverImage: ReactNode
  longitude: number
  latitude: number
}
export const MapboxGeographicPinFeature: FC<MapboxGeographicPinFeatureProps> = (
  props
) => {
  const [showLabel, setShowLabel] = useState(false)

  return (
    <>
      <Marker
        longitude={props.longitude}
        latitude={props.latitude}
        anchor={'bottom'}
        style={{ zIndex: 1 }}>
        <PushPinIcon
          onClick={props.onClick}
          pinColor={props.color}
          onMouseEnter={(e) => {
            e.stopPropagation()
            setShowLabel(true)
          }}
          onMouseLeave={() => setShowLabel(false)}
        />
      </Marker>
      {showLabel && (
        <Marker
          longitude={props.longitude}
          latitude={props.latitude}
          anchor={'bottom'}
          style={{ pointerEvents: 'none', zIndex: 2 }}>
          <LabelDisplay
            name={props.name}
            extraLabelDisplay={props.hoverImage}
          />
        </Marker>
      )}
    </>
  )
}

//--------------------------------------------------------------------------------------------------------------------

export const MapboxGeographicPinFeatureFactory: FC<{
  pin: GeckoGeographicPin
}> = (props) => {
  const { handleClick, hoverImage } = useGetGeographicPinInteractionHandler(
    props.pin
  )

  const [longitude, latitude] = centerOfMass(props.pin.data.geo_json).geometry
    .coordinates

  return (
    <MapboxGeographicPinFeature
      name={props.pin.data.name ?? props.pin.id}
      onClick={handleClick}
      hoverImage={hoverImage}
      color={props.pin.data.geo_json.properties?.color ?? 'red'}
      longitude={longitude}
      latitude={latitude}
    />
  )
}

//====================================================================================================================
export const PIN_SIZE = '25px'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${PIN_SIZE};
  width: ${PIN_SIZE};
`

const PinStem = styled.div`
  height: 60%;
  width: 10%;
  background-color: white;
`

const PinTop = styled.div<{ $color: string }>`
  height: 40%;
  width: 40%;
  background-color: ${(props) => props.$color};
  border-radius: 100%;
`

export const PushPinIcon: FC<
  {
    pinColor: string
  } & HTMLAttributes<HTMLDivElement>
> = ({ pinColor, ...divProps }) => {
  return (
    <Container {...divProps} onClick={divProps.onClick}>
      <PinTop $color={pinColor} />
      <PinStem />
    </Container>
  )
}
